import React, { useState, useEffect } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { configure } from "@testing-library/dom";
import { setSelectionRange } from "@testing-library/user-event/dist/utils";
import headerImg from "../assets/headerbanner.png";
// import fscgovtlogo from "../assets/fsc-govt-card.png"; // Adjust the path as necessary
const FscCard = () => {
  const [fscNumber, setFscNumber] = useState("");
  const [cardDetails, setCardDetails] = useState(null);
  const [debugLog, setDebugLog] = useState("");
  const [memberNames, setMemberNames] = useState([]);
  const [downloadFormat, setDownloadFormat] = useState("png");
  const [showConfig, setShowConfig] = useState(false);
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [format, setFormat] = useState("png");
  const [savedSettings, setSavedSettings] = useState(null);
  const [setting, setSettings] = useState({
    width: "85.6",
    height: "53.98",
    format: "png",
  });

  // Listen for data from the popup
  useEffect(() => {
    const handleMessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.fscData && Array.isArray(data.fscData)) {
          localStorage.setItem("fscData", JSON.stringify(data));
          console.log("✅ FSC data received from popup:", data);
        }
      } catch (e) {
        console.warn("⚠️ Invalid message data received:", event.data);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    const stored = localStorage.getItem("cardSettings");
    if (stored) {
      setSavedSettings(JSON.parse(stored));
    }
  }, []);

  const configureFsc = () => {
    setShowConfig(true);
  };

  const saveSettings = () => {
    const defaultWidth = 800;
    const defaultHeight = 600;

    let finalWidth = width;
    let finalHeight = height;

    if (!width || !height) {
      const confirmUseDefaults = window.confirm(
        "Width and Height should not be blank. Do you want to use default values?"
      );

      if (!confirmUseDefaults) {
        // User chose to cancel
        return;
      }

      finalWidth = width || defaultWidth;
      finalHeight = height || defaultHeight;
    }

    const settings = {
      width: finalWidth,
      height: finalHeight,
      format,
    };

    setSavedSettings(settings);
    setShowConfig(false);
    localStorage.setItem("cardSettings", JSON.stringify(settings));

    alert("Settings saved!");
  };

  const closeSettings = () => {
    setShowConfig(false);
  };

  // Open the EPDS site in a popup
  const openFscSearch = () => {
    localStorage.removeItem("fscData"); // Clear previous data
    window.location.href =
      "https://epds.telangana.gov.in/FoodSecurityAct/?wicket:bookmarkablePage=:nic.fsc.foodsecurity.FscSearch";
  };

  // Handle file upload
  // const handleFileUpload = (event) => {
  //   localStorage.removeItem("fscData");
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     try {
  //       const data = JSON.parse(e.target.result);
  //       if (data.rationCardDetails) {
  //         localStorage.setItem("fscData", JSON.stringify(data));
  //         setCardDetails(data.rationCardDetails);
  //         setMemberNames(data.memberNames);
  //       } else {
  //         throw new Error("Invalid FSC data format.");
  //       }
  //     } catch (err) {
  //       console.error("❌ Failed to parse uploaded file:", err);
  //     }
  //   };
  //   reader.readAsText(file);
  // };

  const handleFileUpload = async (event) => {
    localStorage.removeItem("fscData");
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const buffer = new Uint8Array(e.target.result);
        const salt = buffer.slice(0, 16);
        const iv = buffer.slice(16, 28);
        const data = buffer.slice(28);

        const enc = new TextEncoder();
        const keyMaterial = await window.crypto.subtle.importKey(
          "raw",
          enc.encode("your-secret-password"), // Same passphrase as above
          { name: "PBKDF2" },
          false,
          ["deriveKey"]
        );

        const key = await window.crypto.subtle.deriveKey(
          {
            name: "PBKDF2",
            salt,
            iterations: 100000,
            hash: "SHA-256",
          },
          keyMaterial,
          { name: "AES-GCM", length: 256 },
          false,
          ["decrypt"]
        );

        const decrypted = await window.crypto.subtle.decrypt(
          { name: "AES-GCM", iv },
          key,
          data
        );

        const json = JSON.parse(new TextDecoder().decode(decrypted));
        if (json.rationCardDetails) {
          localStorage.setItem("fscData", JSON.stringify(json));
          setCardDetails(json.rationCardDetails);
          setMemberNames(json.memberNames);
        } else {
          throw new Error("Invalid FSC data format.");
        }
      } catch (err) {
        console.error("❌ Failed to decrypt or parse uploaded file:", err);
        alert("❌ Invalid or corrupted file.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  // Search for FSC number in saved data
  const handleSearch = () => {
    const rawData = localStorage.getItem("fscData");

    if (rawData) {
      setCardDetails(rawData.rationCardDetails);
      setMemberNames(rawData.memberNames);
      console.log("✅ FSC data found in localStorage:", rawData);
      return;
    } else {
      alert("❌ No FSC data found in localStorage.");
    }
  };
  //   const handleDownload = async (type) => {
  //     const frontElement = document.getElementById("fsc-front");
  //     const backElement = document.getElementById("fsc-back");

  //     const downloadImage = async (element, suffix) => {
  //       const canvas = await html2canvas(element, { scale: 3 });
  //       const imgData = canvas.toDataURL(
  //         "image/" + (type === "jpeg" ? "jpeg" : "png")
  //       );
  //       const fileName = `${cardDetails.newRationCardNo}_${suffix}`;

  //       if (type === "pdf") {
  //         const pdf = new jsPDF({
  //           orientation: "landscape",
  //           unit: "mm",
  //           format: [85.6, 53.98],
  //         });
  //         pdf.addImage(imgData, "PNG", 0, 0, 85.6, 53.98);
  //         pdf.save(`${fileName}.pdf`);
  //       } else {
  //         const link = document.createElement("a");
  //         link.href = imgData;
  //         link.download = `${fileName}.${type}`;
  //         link.click();
  //       }
  //     };

  //     if (cardDetails) await downloadImage(frontElement, "front");
  //     if (memberNames.length > 0) await downloadImage(backElement, "back");
  //   };

  const handleDownload = async () => {
    const frontElement = document.getElementById("fsc-front");
    const backElement = document.getElementById("fsc-back");

    // Get settings from localStorage
    // const settings = JSON.parse(localStorage.getItem("cardSettings")) || {
    //   width: "85.6",
    //   height: "53.98",
    //   format: "png",
    // };

    const settings = JSON.parse(localStorage.getItem("cardSettings")) || {
      width: "85.6",
      height: "53.98",
      format: "png",
    };

    console.log("Saved size Settings:", settings);
    const widthMM = parseFloat(settings.width);
    const heightMM = parseFloat(settings.height);
    const format = settings.format;

    const downloadImage = async (element, suffix) => {
      const canvas = await html2canvas(element, { scale: 3 });
      const imgData = canvas.toDataURL(
        `image/${format === "jpeg" ? "jpeg" : "png"}`
      );
      const fileName = `${cardDetails.newRationCardNo}_${suffix}`;

      if (format === "pdf") {
        const pdf = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: [widthMM, heightMM],
        });
        pdf.addImage(imgData, "PNG", 0, 0, widthMM, heightMM);
        pdf.save(`${fileName}.pdf`);
      } else {
        const link = document.createElement("a");
        link.href = imgData;
        link.download = `${fileName}.${format}`;
        link.click();
      }
    };

    if (cardDetails) await downloadImage(frontElement, "front");
    if (memberNames.length > 0) await downloadImage(backElement, "back");
  };

  return (
    <div>
      {/* //header code */}
      <div
        style={{
          backgroundColor: "#6DC38F",
          width: "100%",
          height: "150px",
          borderRadius: "10px",
        }}
      >
        <img
          src={headerImg}
          alt="Logo"
          width="100%"
        //   style={{ width: "100%", height: "auto" }}
        ></img>{" "}
      </div>
      <div className="container mt-1">
        {" "}
        <div className="row">
          {/* Left Side - 8 Columns */}{" "}
          <div className="col-md-10 d-flex align-items-center justify-content-center">
            {" "}
            <button className="btn btn-success me-3" onClick={openFscSearch}>
              New Card{" "}
            </button>{" "}
            <input type="file" accept=".json" onChange={handleFileUpload} />{" "}
          </div>
          {/* Right Side - 4 Columns */}{" "}
          <div className="col-md-2 d-flex flex-column align-items-center justify-content-center">
            {" "}
            <button
              className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
              onClick={configureFsc}
            >
              Configurer{" "}
            </button>{" "}
            {showConfig && (
              <div className="border p-3 rounded">
                {" "}
                <input
                  type="text"
                  placeholder="Width in mm"
                  value={width}
                  onChange={(e) => setWidth(e.target.value)}
                  className="form-control mb-2"
                />{" "}
                <input
                  type="text"
                  placeholder="Height in mm"
                  value={height}
                  onChange={(e) => setHeight(e.target.value)}
                  className="form-control mb-2"
                />
                <label style={{ fontSize: "12px", fontWeight: "bold" }}>
                  Select Format:
                </label>{" "}
                <select
                  value={format}
                  onChange={(e) => setFormat(e.target.value)}
                  className="form-select mb-2"
                >
                  <option value="png">PNG</option>
                  <option value="jpeg">JPEG</option>
                  <option value="pdf">PDF</option>{" "}
                </select>{" "}
                <button
                  className="btn btn-sm btn-primary"
                  onClick={saveSettings}
                >
                  Save{" "}
                </button>{" "}
                <button
                  className="btn btn-sm btn-danger"
                  onClick={closeSettings}
                >
                  Cancel{" "}
                </button>{" "}
              </div>
            )}{" "}
            {savedSettings && (
              <div className="" style={{ fontSize: "11px" }}>
                <p>
                  Width: {savedSettings.width}mm
                  <p>Height: {savedSettings.height}mm </p>
                  <p> Format: {savedSettings.format.toUpperCase()}</p>
                </p>
              </div>
            )}{" "}
          </div>{" "}
        </div>
        {/* FSC Search */}{" "}
        <div className="d-flex flex-column justify-content-center align-items-center mt-5">
          {" "}
          <div>
            {" "}
            <input
              type="text"
              placeholder="Enter FSC Number"
              value={fscNumber}
              onChange={(e) => setFscNumber(e.target.value)}
              style={{ padding: "8px", width: "300px" }}
            />{" "}
            <button
              onClick={handleSearch}
              style={{ marginLeft: "10px", padding: "8px 16px" }}
            >
              Search{" "}
            </button>{" "}
          </div>{" "}
        </div>{" "}
      </div>
      {debugLog && (
        <div style={{ marginTop: "10px", color: "green" }}>
          <strong>{debugLog}</strong>
        </div>
      )}
      <div className="mt-4 text-center">
        <button className="ms-3" onClick={() => handleDownload(downloadFormat)}>
          Download Card
        </button>
      </div>
      {/* code for displaying card details */}
      <div
        id="fsc-front"
        className="mt-4 p-3 border border-2 border-secondary w-75"
        style={{
          marginLeft: "9.3rem",
        }}
      >
        <img
          src={headerImg}
          alt="Logo"
          style={{
            width: "100%",
            borderRadius: "5px",
            filter: "brightness(70%)"
          }}
        />
        <div
          className="d-flex justify-content-center align-items-center mt-1 mb-1 p-1 bg bg-success text-white border rounded"
          style={{
            fontSize: "4.2rem",
            color: "#fff",
            height: "50px",
          }}
        >
          <h2>Ration Card Details:</h2>
        </div>

        <div
          className="d-flex justify-content-center align-items-center mt-1 mb-1 p-2 border border-3 border-success rounded"
          style={{
            fontSize: "5.2rem",
            height: "50px",
          }}
        >
          <h1 className="text-primary">New Ration Card No:</h1>
          <h1 className="text-danger ms-5">
            {cardDetails?.newRationCardNo || "__________"}
          </h1>
        </div>

        <table
          style={{
            borderCollapse: "collapse",
            border: "2px solid #000",
            width: "100%",
          }}
        >

          <tbody>
            {[
              ["Head of the Family", "headOfFamily"],
              ["Card Type", "cardType"],
              ["FSC Reference No", "fscRefNo"],
              ["Application No", "applicationNo"],
              ["Application Status", "appStatus"],
              ["IMPDS Status", "impdsStatus"],
              ["SKS Form No", "sksFormNo"],
              ["FPShop No", "fpShopNo"],
              ["KeyRegister Sl.No", "keyRegisterSlNo"],
              ["Gas Connection", "gasConnection"],
              ["Consumer No", "consumerNo"],
              ["Office Name", "officeName"],
              ["District", "district"],
              ["Old RCNo", "oldRCNo"],
              ["__________", ""],
            ]
              .reduce((rows, item, index, array) => {
                if (index % 3 === 0) {
                  rows.push(array.slice(index, index + 3));
                }
                return rows;
              }, [])
              .map((rowTriplet, index) => (
                <tr key={index} style={{ backgroundColor: "#fff", color: "#000" }}>
                  {rowTriplet.map(([label, key], i) => (
                    <td
                      key={i}
                      // colSpan={1}
                      style={{
                        padding: "8px",
                        border: "2px solid #000",
                        fontSize: "18px",
                        fontWeight: "bold",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span style={{ display: "inline-block", minWidth: "170px" }}>
                        {label}
                      </span>
                      <span>&nbsp;:&nbsp;</span>
                      <span style={{ color: "#007bff", marginLeft: "5px" }}>
                        {cardDetails?.[key] || "__________"}
                      </span>
                    </td>
                  ))}
                  {rowTriplet.length < 3 &&
                    Array.from({ length: 3 - rowTriplet.length }).map((_, i) => (
                      <td
                        key={`empty-${i}`}
                        colSpan={2}
                        style={{ border: "2px solid #000" }}
                      ></td>
                    ))}
                </tr>
              ))}
          </tbody>

        </table>
      </div>

      {/* ======================= */}
      {/* FAMILY MEMBERS DETAILS */}
      {/* ======================= */}
      <div
        id="fsc-back"
        className="mt-5 p-3 border border-2 border-secondary w-75"
        style={{
          marginLeft: "9.3rem",
          // width: "80%",
          // margin: "0 auto",
        }}
      >
        <div className="d-flex justify-content-center align-items-center mb-2">
          <img
            src={headerImg}
            alt="Logo"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "5px",
              filter: "brightness(70%)"
            }}
          />
        </div>

        <h2 className="text-white mb-2 bg bg-success p-2 text-center border rounded">
          Ration Card Family Members Details
        </h2>

        <table
          className="justify-content-center align-items-center"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "center",
            border: "2px solid #000",
          }}
        >
          <tbody>
            <tr
              style={{
                backgroundColor: "#076aa3",
                color: "#fff",
              }}
            >
              <td
                colSpan={2}
                style={{
                  border: "2px solid #000",
                  padding: "8px",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                <span style={{ display: "inline-block", minWidth: "200px", marginLeft: "-2rem" }}>S.No</span>
                <span style={{ display: "inline-block", minWidth: "950px" }}>Name</span>
              </td>
            </tr>
            {memberNames.length > 0 ? (
              memberNames.map((name, index) => (
                <tr
                  key={index}
                  style={{
                    // backgroundColor: index % 2 === 0 ? "#D6F2A1" : "#63c9c9",
                    backgroundColor: "#fff",
                    borderBottom: "2px solid #000",
                    fontSize: "18px"

                  }}
                >
                  <td style={{ padding: "8px", fontWeight: "bold" }}>
                    {index + 1}
                  </td>

                  <td style={{ padding: "8px", fontWeight: "bold", fontSize: "18px" }}>{name}</td>
                  {/* <td></td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" style={{ padding: "8px", fontStyle: "italic" }}>
                  No member data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          margin: "25rem 0rem .5rem 0rem",
          fontSize: "12px",
          color: "#555",
          // width: "80%",
          backgroundColor: "#008080",
        }}
      >
        <p
          style={{
            margin: "0rem 3rem .5rem 3rem",
            color: "#fff",
          }}
        >
          Disclaimer: This information displayed above has been retrieved with
          the explicit consent of the user soley for the purpose of viewing and
          downloading the FSC card. This website does not store, share, or
          misuse any personal data. All data remains the proprty of the
          respective goverment authority and is used here only for user
          requested service. We are not affiliated with any government agency.
          User are advised to verify the accuracy of the information before
          proceeding.
        </p>
      </div>
    </div>
  );
};

export default FscCard;
